export const HELP_CENTER_URL = 'https://help.otter.ai/hc';

export const HELP_CENTER_ARTICLES = {
  INVITE_MEMBERS: `${HELP_CENTER_URL}/articles/360049123413-Invite-members-to-join-your-Workspace`,
  CONVERSATION_PAGE_OVERVIEW: `${HELP_CENTER_URL}/articles/5093228433687-Conversation-Page-Overview#h_01HNXZWNHJ62WNTN3WBM75ZWDY`,
  STOP_FROM_JOINING_MEETINGS: `${HELP_CENTER_URL}/articles/12906714508823-Stop-Otter-Notetaker-from-automatically-joining-your-meetings`,
  CANCEL_OR_DOWNGRADE_ARTICLE: `${HELP_CENTER_URL}/articles/26011568967447-Will-I-still-have-access-to-my-conversations-if-I-cancel-downgrade-or-change-plans`,
  TRANSCRIPTION_ACCURACY_FAQ: `${HELP_CENTER_URL}/articles/360048322533-Transcription-accuracy-FAQ`,
  TROUBLE_SHOOT_AUDIO: `${HELP_CENTER_URL}/articles/4403627500951-Troubleshooting-audio-problems`,
} as const;

export const SALES_URL = 'https://otter.ai/sales';
export const PRICING_URL = 'https://otter.ai/pricing';
export const INTEGRATIONS_URL = 'https://otter.ai/integrations';
export const PRICING_DEMO_URL = 'https://otter.ai/pricing-demo';

export const TERMS_OF_SERVICE_URL = 'https://otter.ai/terms-of-service';
export const PRIVACY_POLICY_URL = 'https://otter.ai/privacy-policy';

export const MOBILE_PAYMENT_SUPPORT_URLS = {
  APPLE_HELP_ARTICLE: 'https://support.apple.com/en-us/HT202039',
  GOOGLE_HELP_ARTICLE:
    'https://support.google.com/googleplay/answer/7018481?hl=en&co=GENIE.Platform%3DAndroid&oco=1',
  APPLE_MANAGE_SUBSCRIPTIONS: 'https://apps.apple.com/account/subscriptions',
  GOOGLE_MANAGE_SUBSCRIPTIONS:
    'https://play.google.com/store/account/subscriptions',
} as const;

export const ZOOM_COMPLIANCE_LEARN_MORE_URL =
  'https://help.otter.ai/hc/en-us/articles/19504911385495-Zoom-compliance-requirements-for-OtterPilot';

export const HELP_CENTER_SUPPORT_FORM_URL =
  'https://help.otter.ai/hc/en-us/requests/new';

export const SALES_TAX_FAQ_URL =
  'https://help.otter.ai/hc/en-us/articles/26572931927959-Sales-Tax-FAQ';

export const APP_STORE_URL =
  'https://itunes.apple.com/us/app/otter-ai/id1276437113?ls=1&mt=8';
export const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.aisense.otter';
export const CHROME_EXTENSION_URL =
  'https://chrome.google.com/webstore/detail/otterai/bnmojkbbkkonlmlfgejehefjldooiedp';

export const SALESFORCE_INTEGRATION_GUIDE_URL =
  'https://help.otter.ai/hc/en-us/articles/15671309340183-Otter-ai-Salesforce-Integration-Guide';
export const ZOOM_INTEGRATION_GUIDE_URL =
  'https://help.otter.ai/hc/en-us/sections/11947382408727-Zoom-Integration';
export const HUBSPOT_INTEGRATION_GUIDE_URL =
  'https://help.otter.ai/hc/en-us/articles/19439009788951-Otter-ai-HubSpot-Integration-Guide';
export const SLACK_INTEGRATION_GUIDE_URL =
  'https://help.otter.ai/hc/en-us/articles/13627121851799-Otter-ai-integration-for-Slack';
export const DROPBOX_INTEGRATION_GUIDE_URL =
  'https://help.otter.ai/hc/en-us/articles/360048070254-Dropbox-for-Otter';

export const ZAPIER_INTEGRATIONS_URL =
  'https://zapier.com/apps/otterai/integrations';

export const APP_DOWNLOAD_DEEP_LINK_URL = 'https://go.onelink.me/KBef/iibsnxjg';
